<template>
<div class="chapter">
<div class="inner_page">
<p class="p-p19">“I write because I’m addicted to storytelling. What I seek more than another blank page to put down my next idea is a reader who enjoys the stories I tell. Now that’s motivation and a reason to keep going.” —Keith Rommel</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?d5b932f6